import React from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import {AppButton} from '@/components/Button';
import {ADVANCED_DIAGNOSTICS_DAMAGE_NONE_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import ROUTE_PATHS from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import deviceTypesService from '@/services/device/deviceTypesService';
import appRouterService from '@/services/route/appRouterService';
import {twx} from '@/utils/tailwindUtils';

import useRedirectToPhase2 from '../hooks/useRedirectToPhase2';

const AdvancedDiagnosticDamageButton = ({deviceType, className}) => {
    const isP1V4 = deviceTypesService.isP1V4(deviceType);
    const redirectToPhase2 = useRedirectToPhase2({disabled: !isP1V4});
    const onNextButtonClick = async () => {
        amplitudeADTracking.trackADNoneOfTheAboveClick();
        googleAnalyticsService.trackAdNoneOfTheAboveClick();

        if (isP1V4) {
            redirectToPhase2();
        } else {
            appRouterService.forwardToSelectIssueAD();
        }
    };

    return (
        <AppButton
            secondary
            light
            onClick={onNextButtonClick}
            className={twx('mx-auto', className)}
            aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_DAMAGE_NONE_BUTTON_ARIA_LABEL)}
        >
            <AemEditableText pageName={ROUTE_PATHS.ADVANCE_DIAGNOSTIC} itemName='damagenonebutton' />
        </AppButton>
    );
};

export default AdvancedDiagnosticDamageButton;
